import * as React from "react"
import { OverlayTrigger, Popover } from "react-bootstrap";
import { FaInfoCircle } from "react-icons/fa";
import { UserProfileStatus } from "../../api/Administration/Model/UserDetail";

interface UserProfileStatusesProps {
  statuses: UserProfileStatus[]
}

export default function UserProfileStatuses(props: UserProfileStatusesProps) {
  const { statuses } = props
  return (<ul className="m-0 p-0 list-unstyled">
    {statuses.map((status, index) => <li key={`ups${index}`} className="text-nowrap">
      {status.Message}
      {status.AdditionalInfo && status.AdditionalInfo.length > 0 &&
        <OverlayTrigger placement="top" delay={{ show: 100, hide: 400 }} overlay={
          <Popover id="ups_popover" className="p-2 mw-100" >
            <ul className="m-0 p-0 list-unstyled">
              {status.AdditionalInfo.map((info, i) => <li key={`ap${index}${i}`}>{info}</li>)}
            </ul>
          </Popover>}>
          <FaInfoCircle className="info-icon-alt" />
        </OverlayTrigger>}
    </li>)}
  </ul>)
}
